export const PRIVATE = 'private';
export const PUBLIC = 'public';
